import { STATUS } from "@/constants/statuses";
import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { injectable } from "tsyringe";

import type { EarnPointsEntity } from "../models/RewardsEarnPointsEntity";

export interface EarnPointsState {
    rewardsEarnPoints: EarnPointsEntity | null;
}

const createInitialState = (): EarnPointsState => ({
    rewardsEarnPoints: null,
});

@injectable()
@StoreConfig({ name: "RewardsEarnPointsStore" })
class RewardsEarnPointsStore extends BaseStore<EarnPointsState> {
    constructor() {
        super(createInitialState());
    }

    setStatus(status: STATUS): void {
        this.update((state) => ({ ...state, status }));
    }
}

export default RewardsEarnPointsStore;
